export const availableGenericImages = {
    "Salon": {
        "appBg": [
            "https://pcs-s3.s3.ap-south-1.amazonaws.com/3/sliders/2022-09-02T00%3A02%3A58.170720_slider.png",
            "https://pcs-s3.s3.ap-south-1.amazonaws.com/4/sliders/2022-09-12T17%3A50%3A01.216472_slider.png",
            "https://pcs-s3.s3.ap-south-1.amazonaws.com/4/sliders/2022-09-12T17%3A53%3A19.216388_slider.png"
        ],
        "footerBg": [
            "https://pcs-s3.s3.ap-south-1.amazonaws.com/3/sliders/2022-09-02T00%3A00%3A28.736124_slider.png",
            "https://pcs-s3.s3.ap-south-1.amazonaws.com/3/sliders/2022-09-02T00%3A00%3A48.562924_slider.png",

        ],
        "loginScreenBg": [
            "https://pcs-s3.s3.ap-south-1.amazonaws.com/3/sliders/2022-09-02T00%3A02%3A33.213150_slider.png",
            "https://pcs-s3.s3.ap-south-1.amazonaws.com/3/sliders/2022-09-02T00%3A02%3A03.890924_slider.png",
            "https://pcs-s3.s3.ap-south-1.amazonaws.com/4/sliders/2022-09-12T17%3A51%3A21.336307_slider.png",
            "https://pcs-s3.s3.ap-south-1.amazonaws.com/4/sliders/2022-09-12T17%3A53%3A01.185845_slider.png"
        ],
        "hamburgerBg": [
            "https://pcs-s3.s3.ap-south-1.amazonaws.com/3/sliders/2022-09-02T00%3A04%3A44.856935_slider.png",
            "https://pcs-s3.s3.ap-south-1.amazonaws.com/3/sliders/2022-09-02T00%3A04%3A28.876477_slider.png",
        ]
    },
    "Restaurant": {
        "appBg": [
            "https://pcs-s3.s3.ap-south-1.amazonaws.com/3/sliders/2022-09-02T00%3A02%3A58.170720_slider.png",
            "https://pcs-s3.s3.ap-south-1.amazonaws.com/4/sliders/2022-09-12T17%3A50%3A01.216472_slider.png",
            "https://pcs-s3.s3.ap-south-1.amazonaws.com/4/sliders/2022-09-12T17%3A53%3A19.216388_slider.png"
        ],
        "footerBg": [
            "https://pcs-s3.s3.ap-south-1.amazonaws.com/3/sliders/2022-09-02T00%3A00%3A28.736124_slider.png",
            "https://pcs-s3.s3.ap-south-1.amazonaws.com/3/sliders/2022-09-02T00%3A00%3A48.562924_slider.png",

        ],
        "loginScreenBg": [
            "https://pcs-s3.s3.ap-south-1.amazonaws.com/3/sliders/2022-09-02T00%3A02%3A33.213150_slider.png",
            "https://pcs-s3.s3.ap-south-1.amazonaws.com/3/sliders/2022-09-02T00%3A02%3A03.890924_slider.png",
            "https://pcs-s3.s3.ap-south-1.amazonaws.com/4/sliders/2022-09-12T17%3A51%3A21.336307_slider.png",
            "https://pcs-s3.s3.ap-south-1.amazonaws.com/4/sliders/2022-09-12T17%3A53%3A01.185845_slider.png"
        ],
        "hamburgerBg": [
            "https://pcs-s3.s3.ap-south-1.amazonaws.com/3/sliders/2022-09-02T00%3A04%3A44.856935_slider.png",
            "https://pcs-s3.s3.ap-south-1.amazonaws.com/3/sliders/2022-09-02T00%3A04%3A28.876477_slider.png",
        ]
    },
    "Courses": {
        "appBg": [
            "https://pcs-s3.s3.ap-south-1.amazonaws.com/3/sliders/2022-09-02T00%3A02%3A58.170720_slider.png",
            "https://pcs-s3.s3.ap-south-1.amazonaws.com/4/sliders/2022-09-12T17%3A50%3A01.216472_slider.png",
            "https://pcs-s3.s3.ap-south-1.amazonaws.com/4/sliders/2022-09-12T17%3A53%3A19.216388_slider.png"
        ],
        "footerBg": [
            "https://pcs-s3.s3.ap-south-1.amazonaws.com/3/sliders/2022-09-02T00%3A00%3A28.736124_slider.png",
            "https://pcs-s3.s3.ap-south-1.amazonaws.com/3/sliders/2022-09-02T00%3A00%3A48.562924_slider.png",

        ],
        "loginScreenBg": [
            "https://pcs-s3.s3.ap-south-1.amazonaws.com/3/sliders/2022-09-02T00%3A02%3A33.213150_slider.png",
            "https://pcs-s3.s3.ap-south-1.amazonaws.com/3/sliders/2022-09-02T00%3A02%3A03.890924_slider.png",
            "https://pcs-s3.s3.ap-south-1.amazonaws.com/4/sliders/2022-09-12T17%3A51%3A21.336307_slider.png",
            "https://pcs-s3.s3.ap-south-1.amazonaws.com/4/sliders/2022-09-12T17%3A53%3A01.185845_slider.png"
        ],
        "hamburgerBg": [
            "https://pcs-s3.s3.ap-south-1.amazonaws.com/3/sliders/2022-09-02T00%3A04%3A44.856935_slider.png",
            "https://pcs-s3.s3.ap-south-1.amazonaws.com/3/sliders/2022-09-02T00%3A04%3A28.876477_slider.png",
        ]
    },
    "Stationery": {
        "appBg": [
            "https://pcs-s3.s3.ap-south-1.amazonaws.com/3/sliders/2022-09-02T00%3A02%3A58.170720_slider.png",
            "https://pcs-s3.s3.ap-south-1.amazonaws.com/4/sliders/2022-09-12T17%3A50%3A01.216472_slider.png",
            "https://pcs-s3.s3.ap-south-1.amazonaws.com/4/sliders/2022-09-12T17%3A53%3A19.216388_slider.png"
        ],
        "footerBg": [
            "https://pcs-s3.s3.ap-south-1.amazonaws.com/3/sliders/2022-09-02T00%3A00%3A28.736124_slider.png",
            "https://pcs-s3.s3.ap-south-1.amazonaws.com/3/sliders/2022-09-02T00%3A00%3A48.562924_slider.png",

        ],
        "loginScreenBg": [
            "https://pcs-s3.s3.ap-south-1.amazonaws.com/3/sliders/2022-09-02T00%3A02%3A33.213150_slider.png",
            "https://pcs-s3.s3.ap-south-1.amazonaws.com/3/sliders/2022-09-02T00%3A02%3A03.890924_slider.png",
            "https://pcs-s3.s3.ap-south-1.amazonaws.com/4/sliders/2022-09-12T17%3A51%3A21.336307_slider.png",
            "https://pcs-s3.s3.ap-south-1.amazonaws.com/4/sliders/2022-09-12T17%3A53%3A01.185845_slider.png"
        ],
        "hamburgerBg": [
            "https://pcs-s3.s3.ap-south-1.amazonaws.com/3/sliders/2022-09-02T00%3A04%3A44.856935_slider.png",
            "https://pcs-s3.s3.ap-south-1.amazonaws.com/3/sliders/2022-09-02T00%3A04%3A28.876477_slider.png",
        ]
    }
}